<template>
  <div class="color__img__wrap">
    <div class="color__slider__container">
      <div ref="carousel" class="slider__pc">
        <div class="color__slider">
          <div
            v-for="(color, index) in productsWithColor.colors"
            :key="`color-${color.product_id}-${color.color}`"
            class="color__item"
            :class="{ 'slide-active': activeIndex === index }"
            @click="emblaApi?.scrollTo(index)"
          >
            <AtomsConsumerImage
              :src="color.main_image"
              :alt="`${productsWithColor.name} ${color.color}`"
              :width="100"
              :height="100"
            />
          </div>
        </div>
        <div v-if="canScrollNext" class="button-next swiper-button">
          <div class="swiper-button-next" @click="emblaApi?.scrollNext()">
            <AtomsConsumerImage
              src="/images/site/feature/howtochoose_recoverywear_sleepitem/next-icon.svg"
              alt="次のカラー"
              :width="24"
              :height="24"
            />
          </div>
        </div>
        <div v-if="canScrollPrev" class="button-prev swiper-button">
          <div class="swiper-button-prev" @click="emblaApi?.scrollPrev()">
            <AtomsConsumerImage
              src="/images/site/feature/howtochoose_recoverywear_sleepitem/prev-icon.svg"
              alt="前のカラー"
              :width="24"
              :height="24"
            />
          </div>
        </div>
      </div>
      <div ref="carouselSp" class="slider__sp">
        <div class="color__slider">
          <div
            v-for="(color, index) in productsWithColor.colors"
            :key="`color-${color.product_id}-${color.color}`"
            class="color__item"
            :class="{ 'slide-active': activeIndexSp === index }"
            @click="emblaApiSp?.scrollTo(index)"
          >
            <AtomsConsumerImage
              :src="color.main_image"
              :alt="`${productsWithColor.name} ${color.color}`"
              :width="100"
              :height="100"
            />
          </div>
        </div>
        <div v-if="canScrollNextSp" class="button-next swiper-button">
          <div class="swiper-button-next" @click="emblaApiSp?.scrollNext()">
            <AtomsConsumerImage
              src="/images/site/feature/howtochoose_recoverywear_sleepitem/next-icon.svg"
              alt="次のカラー"
              :width="24"
              :height="24"
            />
          </div>
        </div>
        <div v-if="canScrollPrevSp" class="button-prev swiper-button">
          <div class="swiper-button-prev" @click="emblaApiSp?.scrollPrev()">
            <AtomsConsumerImage
              src="/images/site/feature/howtochoose_recoverywear_sleepitem/prev-icon.svg"
              alt="前のカラー"
              :width="24"
              :height="24"
            />
          </div>
        </div>
      </div>
    </div>
    <figure class="main">
      <AtomsConsumerImage
        :src="productsWithColor.colors?.[activeIndex]?.main_image || ''"
        :alt="productsWithColor.name"
        :width="412"
        :height="412"
        class="pc-image"
      />
      <AtomsConsumerImage
        :src="productsWithColor.colors?.[activeIndexSp]?.main_image || ''"
        :alt="productsWithColor.name"
        :width="412"
        :height="412"
        class="sp-image"
      />
    </figure>
  </div>
</template>

<script setup lang="ts">
import emblaCarouselVue from "embla-carousel-vue"
import type { ProductsWithColor } from "~/utils/functions/howtochoose_recoverywear_sleepitem"

const props = defineProps<{
  productsWithColor: ProductsWithColor
  selectedColorIndex: number
}>()

const [carousel, emblaApi] = emblaCarouselVue({ axis: "y", align: "center" })
const [carouselSp, emblaApiSp] = emblaCarouselVue({ align: "center" })

const emit = defineEmits<{
  (e: "change", index: number): void
}>()

const activeIndex = ref(0)
const activeIndexSp = ref(0)
const canScrollNext = ref(false)
const canScrollPrev = ref(false)
const canScrollNextSp = ref(false)
const canScrollPrevSp = ref(false)

watch(
  emblaApi,
  (api) => {
    if (api) {
      api.on("select", (event) => {
        // スクロールイベントが発生した時に選択しているカラーのインデックスを取得
        activeIndex.value = event.selectedScrollSnap()
        canScrollNext.value = event.canScrollNext() || false
        canScrollPrev.value = event.canScrollPrev() || false
        emit("change", activeIndex.value)
      })

      api.on("init", (event) => {
        activeIndex.value = props.selectedColorIndex || 0
        event.scrollTo(activeIndex.value, true)
      })

      api.on("slidesInView", (event) => {
        // 画面表示時にデフォルトのカラーと次へと戻るボタンの表示非表示判定を行う
        canScrollNext.value = event.canScrollNext() || false
        canScrollPrev.value = event.canScrollPrev() || false
      })
    }
  },
  { immediate: true },
)

watch(
  emblaApiSp,
  (api) => {
    if (api) {
      api.on("select", (event) => {
        activeIndexSp.value = event.selectedScrollSnap()
        canScrollNextSp.value = event.canScrollNext() || false
        canScrollPrevSp.value = event.canScrollPrev() || false
        emit("change", activeIndexSp.value)
      })

      api.on("init", (event) => {
        activeIndexSp.value = props.selectedColorIndex || 0
        event.scrollTo(activeIndexSp.value, true)
      })

      api.on("slidesInView", (event) => {
        canScrollNextSp.value = event.canScrollNext() || false
        canScrollPrevSp.value = event.canScrollPrev() || false
      })
    }
  },
  { immediate: true },
)
</script>

<style scoped lang="scss">
@import "assets/scss/pages/howtochoose_recoverywear_sleepitem/main";
</style>
